module.exports = "/_next/static/images/bg-453a57aef5693e4ef603f3b8527646dd.jpg";